/* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
import { styled, type StyledProps } from '@compiled/react';

// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIAnswerReportDescriptionWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div({
	paddingBottom: token('space.200'),
});
